//
// --- Types ---

export type SpendQueryDatasetIdType = typeof SPEND_QUERY_DATASET_ID[keyof typeof SPEND_QUERY_DATASET_ID];

//
// --- Constants ---

export const SPEND_QUERY_DATASET_ID = {
  CONTACT: 2874
} as const;
